module.exports = __webpack_public_path__ + "static/media/onboarding-fourth.7bd27ebd.svg";